<!-- 自定义 MessageBox 组件 -->
<template>
  <div class="article-dialog" v-show="isShowMessageBox">
    <!-- <div class="mask" @click="cancel"></div> -->
    <div class="mask"></div>
    <div class="article-dialog-con">
      <div class="close" @click="cancel"><i></i></div>
      <h3 class="header-title">{{ columnTitle }}</h3>
      <div class="content">
        <div class="article-type">
          <span class="time">{{date}}</span>
        </div>
        <h1 class="article-title">{{title}}</h1>
        <div class="article-body" v-html="content"></div>
      </div>
    </div>
  </div>
</template>
 
<script>
  export default {
    props: {
      columnTitle: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      date:{
        type:String,
        default:''
      },
      content: {
        type: String,
        default: ''
      },
    },
    data () {
      return {
        isShowMessageBox: false,
      };
    },
    methods: {
      // 确定,将promise断定为resolve状态
      confirm: function () {
        this.isShowMessageBox = false;
      },
      // 取消,将promise断定为reject状态
      cancel: function () {
        this.isShowMessageBox = false;
        $('.content').scrollTop(0);
      },
      // 弹出messageBox,并创建promise对象
      showMsgBox: function () {
        this.isShowMessageBox = true;
        $('.content').scrollTop(0);
      },
      remove: function () {
        setTimeout(() => {
          this.destroy();
        }, 300);
      },
      destroy: function () {
        this.$destroy();
        document.body.removeChild(this.$el);
      }
    }
  };
</script>
 
<style scoped lang="scss">
.article-dialog {
  position: relative;
  .mask {
    position: fixed;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50000;
    background: rgba(0, 0, 0, 0.7);
  }
  .article-dialog-con {
    position: fixed;
    box-sizing: border-box;
    width: 1248px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 50001;
    height: 80%;
    .close {
      position: absolute;
      top: 15px;
      right: 20px;
      width: 20px;
      height: 20px;
      background: url('../../../../static/img/close.png') no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .header-title {
      height: 50px;
      font-size: 20px;
      color: #bfae61;
      font-weight: 400;
      font-family: HelveticaLTPro-Bold;
      line-height: 54px;
      padding-left: 18px;
      width: 1190px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .content {
      border-top: 1px solid #333333;
      padding: 0px 150px;
      height: 90%;
      overflow-y: scroll;
      .article-type{
        margin-top: 50px;
        span{
          display: inline-block;
          vertical-align: bottom;
          &.time{
            font: 400 16px/28px HelveticaLTPro-Light;
            color: #999999;
          }
        }
      }
      .article-title{
        font: 400 48px/65px HelveticaLTPro-Bold;
        margin-top: 36px;
      }
      /deep/ .article-body{
        font: 400 20px/32px HelveticaLTPro-Roman;
        p{
          margin-top: 36px;
          strong{
            font: 400 20px/32px HelveticaLTPro-Bold;
          }
          video , audio , img{
            max-width: 100%;
            display: block;
            margin: auto;
            height: auto;
          }
          span{
            text-wrap: unset !important;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1560px) and (min-width: 1261px){

}

@media screen and (max-width: 1260px) and (min-width: 769px){
  .article-dialog {
    position: relative;
    .mask {
      position: fixed;
      top: 0px;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 50000;
      background: rgba(0, 0, 0, 0.7);
    }
    .article-dialog-con {
      position: fixed;
      box-sizing: border-box;
      width: 680px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      z-index: 50001;
      height: 80%;
      .close {
        position: absolute;
        top: 15px;
        right: 20px;
        width: 20px;
        height: 20px;
        background: url('../../../../static/img/close.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
      .header-title {
        height: 50px;
        font-size: 20px;
        color: #bfae61;
        font-weight: 400;
        font-family: HelveticaLTPro-Bold;
        line-height: 54px;
        padding-left: 30px;
        width: 620px;
      }
      .content {
        padding: 0px 30px;
        height: 90%;
        overflow-y: scroll;
        border-top: 1px solid #a0a0a0;
        .article-type{
          margin-top: 44px;
          span{
            display: inline-block;
            vertical-align: bottom;
            &.time{
              font: 400 16px/28px HelveticaLTPro-Light;
              color: #999999;
            }
          }
        }
        .article-title{
          font: 400 32px/52px HelveticaLTPro-Bold;
          margin-top: 34px;
        }
        /deep/ .article-body{
          font: 400 20px/32px HelveticaLTPro-Roman;
          p{
            margin-top: 34px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px){
  .article-dialog {
    position: relative;
    .mask {
      position: fixed;
      top: 0px;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 50000;
      background: rgba(0, 0, 0, 0.7);
    }
    .article-dialog-con {
      position: fixed;
      box-sizing: border-box;
      width: 24.44rem;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      z-index: 50001;
      height: 80%;
      .close {
        position: absolute;
        top: .665rem;
        right: .56rem;
        width: .89rem;
        height: .89rem;
        background: url('../../../../static/img/close.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
      .header-title {
        height: 2.22rem;
        font-size: .89rem;
        color: #bfae61;
        font-weight: 400;
        font-family: HelveticaLTPro-Bold;
        line-height: 2.44rem;
        padding-left: 1.89rem;
        width: 22rem;
      }
      .content {
        padding: 0px 1.89rem;
        height: 90%;
        overflow-y: scroll;
        border-top: 1px solid #333333;
        .article-type{
          margin-top: 1.89rem;
          span{
            display: inline-block;
            vertical-align: bottom;
            &.time{
              font: 400 .89rem/1.56rem HelveticaLTPro-Light;
              color: #999999;
            }
          }
        }
        .article-title{
          font: 400 1.56rem/2.22rem HelveticaLTPro-Bold;
          margin-top: 1.56rem;
        }
        /deep/ .article-body{
          font: 400 .89rem/1.33rem HelveticaLTPro-Roman;
          p{
            margin-top: 1.67rem;
            strong{
              font: 400 .89rem/1.33rem HelveticaLTPro-Bold;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/article-dialog/index.vue